// extracted by mini-css-extract-plugin
export default {"wrapper":"TipTapView_wrapper__P958M","tiptapClassContentShow":"TipTapView_tiptapClassContentShow__jVUcD"};